import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import sortBy from 'lodash-es/sortBy';

const handleClick = (id) => {
  const event = new CustomEvent('shouldFocusMarkerId', { detail: id });
  document.dispatchEvent(event);
};

const LocationsInRange = () => {
  const [locations, setLocations] = useState([]);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const fn = (e) => {
      const data = e.detail;

      document.querySelector('[data-location-count]').innerHTML = data.locations.length;
      document.querySelector('[data-location-range]').innerHTML = data.range;

      const sortedLocations = sortBy(data.locations, (item) => item.properties.distance);
      setLocations(sortedLocations);
      setInitialized(true);
      document.querySelector('[data-store-locator-results]').classList.remove('StoreLocator__results--loading');
    };

    document.addEventListener('locationsInRangeDidUpdate', fn);

    return () => {
      document.removeEventListener('locationsInRangeDidUpdate', fn);
    };
  }, []);

  const openChat = () => {
    window.adaEmbed.start({
      handle: 'windsorfashions',
      metaFields: {
        username: 'Ada Lovelace',
        phone_number: '123-456-7890',
      },
      chatterTokenCallback: (chatter) => console.log(chatter),
    });

    window.adaEmbed.toggle();
  };

  return (
    <div className="LocationsInRange">
      {locations.length > 0 &&
        locations.map((item, i) => {
          const searchTerm = escape(
            `${item.properties.street_1} ${item.properties.city}, ${item.properties.state} ${item.properties.zip}`,
          );
          const mapUrl = `https://www.google.com/maps/search/?api=1&query=windsor+/${searchTerm}`;

          return (
            <div className="LocationsInRange__item" key={`LocationsInRange-item-${i}`}>
              <div className="LocationsInRange__left">
                {item.properties.name && item.properties.name !== 'false' && (
                  <a
                    className="LocationsInRange__name"
                    onClick={() => {
                      handleClick(item.properties.store_number);
                    }}
                  >
                    {item.properties.name}
                  </a>
                )}
                {item.properties.street_1 && item.properties.street_1 !== 'false' && (
                  <div className="LocationsInRange__street_1">{item.properties.street_1}</div>
                )}
                {item.properties.street_2 && item.properties.street_2 !== 'false' && (
                  <div className="LocationsInRange__street_2">{item.properties.street_2}</div>
                )}

                <div className="LocationsInRange__city-state-zip">
                  {item.properties.city}, {item.properties.state} {item.properties.zip}
                </div>

                <a className="LocationsInRange__chat-message" onClick={openChat}>
                  CHAT WITH US
                </a>

                {item.properties.store_number && item.properties.store_number.length > 0 && (
                  <div className="LocationsInRange__store-number">Store #{item.properties.store_number}</div>
                )}
              </div>
              <div className="LocationsInRange__right">
                {item.properties.distance && item.properties.distance !== 'false' && (
                  <div className="LocationsInRange__distance">{Math.round(item.properties.distance * 10) / 10} mi</div>
                )}

                <a className="LocationsInRange__directions" href={mapUrl} target="_blank" rel="noopener noreferrer">
                  Get&nbsp;Directions
                </a>

                <a className="LocationsInRange__details" data-store={item.properties.name} href={item.properties.url}>
                  Full&nbsp;Details
                </a>
              </div>
            </div>
          );
        })}

      {initialized && locations.length === 0 && <div className="LocationsInRange__no-results">Sorry, no results</div>}
    </div>
  );
};

export default () => {
  const el = document.querySelector('[data-store-locator-locations]');
  if (!el) {
    return;
  }
  ReactDOM.render(<LocationsInRange />, el);

  console.log('init store locator');
};
